import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { LazyLoadImageModule, LAZYLOAD_IMAGE_HOOKS } from 'ng-lazyload-image';

import { ImageComponent } from '@fcom/ui-components/components/images/image/image.component';

import { PipesModule } from '../../pipes/pipes.module';
import { BlockImageComponent } from './block-image.component';
import { ContentImageComponent } from './content-image.component';
import { LazyLoadImageHooks } from './images.utils';
import { LqipImageModule } from './lqip-image/lqip-image.module';

@NgModule({
  imports: [CommonModule, PipesModule, ImageComponent, LazyLoadImageModule, LqipImageModule],
  providers: [{ provide: LAZYLOAD_IMAGE_HOOKS, useClass: LazyLoadImageHooks }],
  declarations: [BlockImageComponent, ContentImageComponent],
  exports: [BlockImageComponent, ContentImageComponent, ImageComponent],
})
export class ImagesModule {}
